var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { memo, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import UserProfileForm from '../../../social/components/UserProfileForm';
import customizableComponent from '../../../core/hocs/customization';
import withSDK from '../../../core/hocs/withSDK';
import { backgroundImage as UserImage } from '../../../icons/User';
import useUser from '../../../core/hooks/useUser';
import { isEmpty } from '../../../helpers';
import PageLayout from '../../../social/layouts/Page';
import PageHeader from '../../../core/components/PageHeader';
import { useNavigation } from '../../../social/providers/NavigationProvider';
import { Tabs, tabs } from './constants';
import { ProfileSettingsTabs, ActiveTabContent, ActiveTabContainer } from './styles';
const ProfileSettings = ({ userId, client }) => {
    const { formatMessage } = useIntl();
    const { onClickUser } = useNavigation();
    const [activeTab, setActiveTab] = useState(Tabs.EDIT_PROFILE);
    const { user, file } = useUser(userId);
    const onBack = () => {
        onClickUser(userId);
    };
    const handleSubmit = (data) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield client.updateCurrentUser(data);
        }
        catch (err) {
            console.log(err);
        }
        onBack();
    });
    if (isEmpty(user)) {
        return null;
    }
    return (React.createElement(PageLayout, { header: React.createElement(React.Fragment, null,
            React.createElement(PageHeader, { title: React.createElement(FormattedMessage, { id: "profile.setting" }), avatarFileUrl: file.fileUrl, avatarImage: UserImage, backLinkText: formatMessage({ id: 'ProfileSettings.returnTo' }) + user.displayName, hideBackArrow: true, onBack: onBack }),
            React.createElement(ProfileSettingsTabs, { tabs: tabs, activeTab: activeTab, onChange: setActiveTab })) },
        React.createElement(ActiveTabContainer, null, activeTab === Tabs.EDIT_PROFILE && (React.createElement(ActiveTabContent, null,
            React.createElement(UserProfileForm, { user: user, onSubmit: handleSubmit }))))));
};
export default memo(withSDK(customizableComponent('ProfileSettings', ProfileSettings)));
//# sourceMappingURL=index.js.map